import { render, staticRenderFns } from "./TMResultsSortDropdown.vue?vue&type=template&id=8e66c440"
import script from "./TMResultsSortDropdown.vue?vue&type=script&lang=js"
export * from "./TMResultsSortDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports